var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M346.706,120.608c-0.231-13.799-11.604-24.799-25.404-24.567l-142.885,2.39 c-13.796,0.234-24.799,11.608-24.567,25.405l0.347,20.822c0.003,0.148,0.049,0.29,0.052,0.436c0,0.15-0.04,0.289-0.036,0.439 l2.092,124.926c0.169,10.142,8.52,18.213,18.657,18.042c10.133-0.165,18.211-8.518,18.041-18.656l-1.688-100.814l16.007-0.269 l0.537,32.105l1.378,82.375l2.803,167.479c0.171,10.139,8.524,18.211,18.656,18.047c10.138-0.171,18.212-8.522,18.043-18.657 l-2.803-167.479l14.053-0.239l2.808,167.48c0.163,10.142,8.518,18.212,18.649,18.039c10.14-0.163,18.217-8.516,18.046-18.654 l-2.806-167.481l-1.378-82.373l-0.539-32.106l16.011-0.268l1.684,100.82c0.17,10.14,8.516,18.211,18.655,18.039 c10.139-0.17,18.211-8.517,18.04-18.655l-2.086-124.927c-0.007-0.149-0.043-0.291-0.056-0.439c0-0.148,0.044-0.288,0.037-0.437 L346.706,120.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M290.157,47.154c0.386,22.71-17.723,41.43-40.437,41.81c-22.71,0.38-41.432-17.723-41.809-40.434 C207.53,25.819,225.634,7.1,248.344,6.718C271.055,6.34,289.779,24.444,290.157,47.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M147.511,504.299l43.45-78.535l123.149-2.063l52.449,76.938L147.511,504.299z M198.397,438.137 L168.9,491.45l174.28-2.916l-35.6-52.229L198.397,438.137z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.4dc519f5.svg";
export { ForwardRef as ReactComponent };